import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { ROUTE_GROUPS_SOFTWARE } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarPlan from '@atlassian/jira-navigation-apps-sidebar-plan/src/async.tsx';
import { planLayout } from '@atlassian/jira-plan-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/index.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/index.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@atlassian/jira-router-resources-advanced-roadmaps-plan/src/services/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { softwarePlanSettingsPermissionsRoute } from '@atlassian/jira-router-routes-advanced-roadmaps-routes/src/softwarePlanSettingsPermissionsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanSettingsPermissionsPage, {
	LazyPlanSettingsPermissions,
} from './ui/plan-settings-permissions/index.tsx';

export const softwarePlanSettingsPermissionsRouteEntry: Route = createEntry(
	softwarePlanSettingsPermissionsRoute,
	() => ({
		group: ROUTE_GROUPS_SOFTWARE,
		component: PlanSettingsPermissionsPage,
		layout: composeLayouts(globalLayout, planLayout),
		resources: [
			...getNavigationResources(),
			...getNavigationSidebarPlanResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
			advancedRoadmapsReduxStoreStateResource,
		],
		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},
		navigation: {
			sidebarId: SIDEBAR_ID.PLAN_SETTINGS,
			menuId: MENU_ID.PLANS,
			sidebar: AsyncSidebarPlan,
		},
		forPaint: [LazyAtlassianNavigation, LazyPlanSettingsPermissions],
	}),
);
